export default __webpack_public_path__ + "assets/0e031562aca26eb86cc988ca077b7d4a.png";